module.exports = __webpack_public_path__ + "static/media/my_assets_bank_card.b173d417.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_bank_card.png
// module id = 745
// module chunks = 0 1